module.exports = __webpack_public_path__ + "img/livepen-order.f3c57fa9.png";